import {
  GET_VENDOR_DASHBOARD_REQUEST,
  GET_VENDOR_DASHBOARD_SUCCESS,
  GET_VENDOR_DASHBOARD_FAILURE,
} from "./type";

export const getVendorDashboardRequest = (data) => {
  return { type: GET_VENDOR_DASHBOARD_REQUEST, payload: data };
};

export const getVendorDashboardSuccess = (data) => {
  return { type: GET_VENDOR_DASHBOARD_SUCCESS, payload: data };
};

export const getVendorDashboardFailure = () => {
  return { type: GET_VENDOR_DASHBOARD_FAILURE };
};
